import React, { useState, useEffect, useRef, useCallback } from 'react';
import Navbar from '../NavBar/navbar';
import CompanyForm from '../CompanyForm/companyForm';
import Lsidebar from '../LSidebar/lsidebar';
import { toast, ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { handleAPIRequest } from '../../api/api';
import { useNavigate } from 'react-router-dom';
import { logout } from "../../redux/AuthSlice";
import axios from 'axios';
import { getServerBaseUrl } from '../../api/base_url.js';
const HomePage = () => {
  const getBase = getServerBaseUrl();
      const dispatch = useDispatch();
      const navigate = useNavigate();
    const token = useSelector((state) => state.auth.token); 
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [selectedCompanyId, setSelectedCompanyId] = useState(null);
  const [companies,setCompanies] = useState([]);
        const [isEditable,setIsEditable]= useState(false);

        const [errors, setErrors] = useState({});
    const handleCompanySelect = async (company) => {
      setErrors({});
      setIsEditable(true);
      setSelectedCompanyId(company.id);

      try {
            const response = await handleAPIRequest('get', `get-single-company-details/${company.id}`, null, null, token);
      
            if (response.status === 200)
            {
                setCompanyData({
                    companyName: response.data.data.name,
                    companyType: response.data.data.type,
                    companyLinks: response.data.data.link,
                    companyLocation: response.data.data.location,
                    companyAbout: response.data.data.about,
                    companyProducts: response.data.data.products,
                    companyServices: response.data.data.services,
                    chat_Url: response.data.data.chat_url,
                    secretKey: response.data.data.secret_key,
                    logo: response.data.data.logo_url
                });
            }
          } catch (error) {
            const errorMessage = error?.message || error.toString();
          
            if (errorMessage.includes("401")) {
              alert("Session Expired");
              dispatch(logout());
              navigate("/");
              return;
            }
            console.error('Error fetching details for single company:', error);
          }
    };

    const resetForm =() => {
      setCompanyData({
        companyName: '',
        companyType: '',
        companyLinks: '',
        companyLocation: '',
        companyAbout: '',
        companyProducts: '',
        companyServices: '',
        chat_Url:'',
        secretKey:'',
        logo: null,
    });
    setIsEditable(false);
    setSelectedCompanyId(null);
    setErrors({});
    }
    const [companyData, setCompanyData] = useState({
        companyName: '',
        companyType: '',
        companyLinks:'',
        companyLocation:'',
        companyAbout:'',
        companyProducts: '',
        companyServices: '',
        chat_Url: '',
        secretKey:'',
        logo: null,
    });

    // Handle input change
    const handleChange = (e) => {
      const { name, value } = e.target;
  
      // If the field is companyName, check for word count limit
      if (name === "companyName") {
          const wordCount = value.trim().split(/\s+/).length;
          if (wordCount > 2) {
              setErrors(prev => ({ 
                  ...prev, 
                  companyName: "Company Name cannot exceed two words!"
              }));
          } else {
              setErrors(prev => ({ 
                  ...prev, 
                  companyName: "" 
              }));
          }
      }
  
      setCompanyData(prev => ({
          ...prev,
          [name]: value
      }));
  };
    const fetchCalled = useRef(false);

    const fetchCompanies = useCallback(async () => {
      try {
        const response = await handleAPIRequest('get', 'all-companies', null, null, token);
        setCompanies(response.data.companies || []);
      } catch (error) {
        const errorMessage = error?.message || error.toString();
            
        if (errorMessage.includes("401")) {
          alert("Session Expired");
          dispatch(logout());
          navigate("/");
          return;
        }
        console.error('Error showing all companies:', error);
      }
    }, [token, dispatch, navigate]); // Dependencies to ensure it remains stable
    
    useEffect(() => {
      if (token && !fetchCalled.current) {
        fetchCompanies();
        fetchCalled.current = true; // Mark as called
      }
    }, [token, fetchCompanies]); // Stable fetchCompanies reference
  
  

    const handleSubmit = async () => {
        try {
            const formData = new FormData();
            formData.append('companyName', companyData.companyName);
            formData.append('companyType', companyData.companyType);
            formData.append('companyLinks', companyData.companyLinks);
            formData.append('companyLocation', companyData.companyLocation);
            formData.append('companyAbout', companyData.companyAbout);
            formData.append('companyProducts', companyData.companyProducts);
            formData.append('companyServices', companyData.companyServices);
            formData.append('chat_Url', companyData.chat_Url);
            formData.append('secretKey', companyData.secretKey);
    
            if (companyData.logo) {
                formData.append('logo', companyData.logo); // must be a File object
            }
    
            const response = await axios.post(
                `${getBase}/add-company-details`, 
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        // DO NOT SET 'Content-Type': 'multipart/form-data' manually here
                    }
                }
            );
    
            toast.success(response.data.message);
            fetchCompanies();
            setCompanyData({
                companyName: '',
                companyType: '',
                companyLinks: '',
                companyLocation: '',
                companyAbout: '',
                companyProducts: '',
                companyServices: '',
                chat_Url:'',
                secretKey:'',
                logo: null,
            });
            setSelectedCompanyId(null);
        } catch (error) {
            const errorMessage = error?.message || error.toString();
    
            if (errorMessage.includes("401")) {
                alert("Session Expired");
                dispatch(logout());
                navigate("/");
                return;
            }
    
            console.error('Error submitting form:', error.response?.data || error);
            alert('Failed to submit form. Try again later.');
        }
    };
    
    const editCompanyDetails = async() =>{
    
      // e.preventDefault();
      try {
          const response = await handleAPIRequest('post',`edit-company-details/${selectedCompanyId}`,companyData,null,token);
          toast.success(response.data.message);
          setIsEditable(false);
          fetchCompanies();
          setCompanyData({
              companyName: '',
              companyType: '',
              companyLinks: '',
              companyLocation: '',
              companyAbout: '',
              companyProducts: '',
              companyServices: '',
              chat_Url:'',
              secretKey:'',
              logo: null,
          });
          setSelectedCompanyId(null);
      } catch (error) {
        const errorMessage = error?.message || error.toString();
        
        if (errorMessage.includes("401")) {
          alert("Session Expired");
          dispatch(logout());
          navigate("/");
          return;
        }
       
          console.error('Error submitting form:', error);
          alert('Failed to submit form. Try again later.');
      }
        
    }    
    return (
        <div className="flex flex-col min-h-screen bg-gray-200">
            <Navbar isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen}/>

            <div className="flex flex-1">
                {/* Sidebar */}
                <div className="">
                <Lsidebar
        companies={companies}
        setCompanies={setCompanies}
        onAddCompanyClick={() => alert('Add Company Clicked')}
        onCompanySelect={handleCompanySelect}
        token={token}
        selectedCompanyId={selectedCompanyId}
        setSelectedCompanyId={setSelectedCompanyId}
        mainLoading={false}
        isSidebarOpen={isSidebarOpen}
        setIsSidebarOpen={setIsSidebarOpen}
        resetForm={resetForm}
      />
      </div>
                {/* Main Content */}
                <div className="flex-1 flex justify-center items-start p-4 sm:p-6 w-full max-w-full">
                    <CompanyForm
                        companyData={companyData}
                        handleChange={handleChange}
                        handleSubmit={handleSubmit}
                        handleEdit={editCompanyDetails}
                       setCompanyData={setCompanyData}
                       isEditable={isEditable}
                       resetForm={resetForm}
                       errors={errors}
                        setErrors={setErrors}
                    />
                </div>
            </div>

            {/* Footer */}
            {/* <Footer /> */}
            <ToastContainer/>
        </div>
    );
};

export default HomePage;
